import { vaultRequest } from './request';

const GET_KYB_BY_ID_QUERY = `
query VaultKyb($vaultKybId: ID!) {
  vaultKyb(id: $vaultKybId) {
    url
    type
    taxId
    structure
    phoneNumber
    legalName
    id
    email
    customerFacingName
    address {
      unit
      street
      region
      postalCode
      city
    }
  }
}
`;

export const getKybById = async (vaultKybId: string): Promise<Kyb> => {
  const kybRes = await vaultRequest(GET_KYB_BY_ID_QUERY, {
    vaultKybId,
  });
  const kybData = await kybRes.json();
  if (kybData.errors) {
    throw new Error(JSON.stringify(kybData.errors));
  }
  return kybData.data.vaultKyb;
};
